module.exports = __webpack_public_path__ + "build-white.png?cdc343919fbf2f95610f665cbf61801d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/build-white.png
// module id = 22
// module chunks = 0